import script from "./MaturSuksma.vue?vue&type=script&setup=true&lang=js"
export * from "./MaturSuksma.vue?vue&type=script&setup=true&lang=js"

import "./MaturSuksma.vue?vue&type=style&index=0&id=7eee2be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eee2be6"]])

export default __exports__